import { render } from "./SolucaoForm.vue?vue&type=template&id=931bf9d6"
import script from "./SolucaoForm.vue?vue&type=script&lang=js"
export * from "./SolucaoForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__